import { RoomInfo } from '../components/Room/types';

export const getWordList = (roomInfo: RoomInfo) => {
    switch (roomInfo.wordList) {
        case 'general_is':
            return 'Íslenska';
        case 'sentences_en':
            return 'Sentences';
        case 'general_en':
            return 'English';
        case 'christmas_en':
            return 'Christmas';
        case 'christmas_is':
            return 'Jóla';
        default:
            return 'English';
    }
};

export const getWordListInfo = (roomInfo: RoomInfo) => {
    if (roomInfo.useCustomWords && !roomInfo.blendCustomWords) {
        return 'custom words';
    } else if (roomInfo.useCustomWords && roomInfo.blendCustomWords) {
        return `custom words and ${getWordList(roomInfo)}`;
    }

    return getWordList(roomInfo);
};
